import React from 'react';

import {EditorPropertiesContext} from 'notebook/notes/core-ui/NoteContext';

interface BlobLinkPreviewTabConsumerProps {
  children: (props: {fileId?: string}) => JSX.Element | null;
}

export function BlobLinkPreviewTabConsumer(props: BlobLinkPreviewTabConsumerProps): JSX.Element {
  return <EditorPropertiesContext.Consumer>{props.children}</EditorPropertiesContext.Consumer>;
}

interface BlobLinkPreviewTabProviderProps {
  fileId: string;
  children: JSX.Element;
}

/**
 * Provides the necessary props for BlobLinkList to open a preview in a new tab
 *
 * This wraps the notebook EditorPropertiesContext since a lot of these tag rendering components are coupled
 * with notebook.
 *
 * TODO(BNCH-20316): Refactor out the notebook dependency
 */
export function BlobLinkPreviewTabProvider(props: BlobLinkPreviewTabProviderProps): JSX.Element {
  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values -- Disabling for now, but worth fixing
    <EditorPropertiesContext.Provider value={{fileId: props.fileId, showFormulas: false}}>
      {props.children}
    </EditorPropertiesContext.Provider>
  );
}
